import type { Locale } from '@mfw/translations';

import { getLocalizedNameByLocale } from '@mfw/components';
import { v4 as uuid } from 'uuid';

import type { UiCreateTag, ApiTag, UiTag } from '../../schemas/tags.schema';

import { mapStatusFromApi, mapStatusToApi } from './status.mappers';
import { mapConfigurableFromApi } from './configurables.mappers';
import { getLabelFromTranslations } from '../../utils';
export function mapTagFromApi(locale: Locale, apiTag: ApiTag): UiTag {
  return {
    id: apiTag?.id ?? uuid(),
    configurables:
      apiTag?.configurables?.map((configurable) => {
        const mappedConfigurable = mapConfigurableFromApi(configurable);
        return {
          label: getLabelFromTranslations(
            locale,
            mappedConfigurable.translations,
          ),
          value: configurable.id,
        };
      }) ?? [],
    createdAt: apiTag?.createdAt ?? '',
    // Global rows come back as `null`; the UI schema only accepts a string.
    organizationId: apiTag.organizationId ?? undefined,
    parentTagId: apiTag?.parentTagId ?? null,
    seedKey: apiTag?.seedKey ?? null,
    status: [{ value: mapStatusFromApi(apiTag?.status ?? 'ACTIVE') }],
    translations: apiTag.translations.map((translation) => ({
      id: translation.id,
      locale: [
        {
          label: getLocalizedNameByLocale(translation.locale),
          value: translation.locale,
        },
      ],
      name: translation.name,
    })),
    updatedAt: apiTag?.updatedAt ?? '',
  };
}

export function mapTagToApi(uiTag: UiCreateTag) {
  const { configurables, parentTagId, status } = uiTag;
  return {
    configurables: configurables.map((configurable) => configurable.value),
    ...(parentTagId ? { parentTagId } : {}),
    status: mapStatusToApi(status[0].value),
    translations: uiTag.translations.map((translation) => ({
      locale: translation.locale[0].value,
      name: translation.name,
    })),
  };
}
